import { useQuery } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";

export function useGetLink() {

    const client = useRestClient();

	const query = useQuery({
		queryKey: ['link'],
		queryFn: client.getLink,
		retry: 3,
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	});

	return {
		link: query.data,
		isLoading: query.isLoading,
		error: query.error,
	};

}